import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekday from "dayjs/plugin/weekday";
import weekYear from "dayjs/plugin/weekYear";
import weekOfYear from "dayjs/plugin/weekOfYear";
import localeData from "dayjs/plugin/localeData";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import localizedFormat from "dayjs/plugin/localizedFormat";
import badMutable from "dayjs/plugin/badMutable";
import isMoment from "dayjs/plugin/isMoment";
import type { Dayjs, PluginFunc } from "dayjs"; // 233
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { forEach, has } from "ramda";
import { isString } from "@/utils";

const localeMap = {
  en_GB: "en-gb",
  en_US: "en",
  zh_CN: "zh-cn",
  zh_TW: "zh-tw",
};
type locale = keyof typeof localeMap;
const parseLocale = function parseLocale(locale: locale) {
  const mapLocale = localeMap[locale];
  return mapLocale || locale.split("_")[0];
};
dayjs.extend((option, dayjsClass) => {
  const oldLocale = dayjsClass.prototype.locale;
  (dayjsClass.prototype.locale as any) = function (this: void, arg: locale) {
    if (isString(arg)) {
      arg = parseLocale(arg) as locale;
    }
    return oldLocale.call(this, arg);
  };
});
interface PluginFuncDto {
  name: string;
  plugin: PluginFunc;
}
function dayExtend({ name, plugin }: PluginFuncDto) {
  const wind: any = window;
  dayjs.extend(plugin);
  wind[`dayjs_plugin_${name}`] = function <T>(option: T, c: typeof Dayjs, d: typeof dayjs) {
    if (!has(name, c.prototype)) {
      plugin(option, c, d);
    }
  };
}
(window as any).moment = dayjs;
forEach(dayExtend, [
  { plugin: advancedFormat, name: "advancedFormat" },
  { plugin: customParseFormat, name: "customParseFormat" },
  { plugin: localeData, name: "localeData" },
  { plugin: quarterOfYear, name: "quarterOfYear" },
  { plugin: weekOfYear, name: "weekOfYear" },
  { plugin: weekYear, name: "weekYear" },
  { plugin: weekday, name: "weekday" },
  { plugin: duration, name: "duration" },
  { plugin: isSameOrBefore, name: "isSameOrBefore" },
  { plugin: isSameOrAfter, name: "isSameOrAfter" },
  { plugin: localizedFormat, name: "localizedFormat" },
  { plugin: badMutable, name: "badMutable" },
  {
    plugin: isMoment,
    name: "isMoment",
  },
]);
export function locale(key: string) {
  // console.log();

  dayjs.locale(key);
}
